<template>
	<div class="feedback">
		<div class="feedback__inner _cnt">
			<div class="feedback__title _h2">{{ $t('Get in touch') }}</div>
			<form class="feedback__form" @submit.prevent="sendFeedback">
				<div class="feedback__body">
					<div class="feedback__raw">
						<BaseInput
							v-model="name"
							type="text"
							:label="`${$t('First Name')}:`"
							class="feedback__input"
							required
						/>
						<BaseInput
							v-model="surname"
							type="text"
							:label="`${$t('Last Name')}:`"
							class="feedback__input"
						/>
					</div>
					<div class="feedback__raw">
						<BaseInput
							v-model="email"
							type="email"
							:label="`${$t('Email')}:`"
							class="feedback__input"
							required
						/>
						<BaseInput
							v-model="phone"
							type="tel"
							:label="`${$t('Phone')}:`"
							class="feedback__input"
							required
						/>
					</div>
					<BaseInput
						v-model="address"
						type="tel"
						:label="`${$t('Address')}:`"
						class="feedback__input"
						required
					/>
					<BaseInput
						v-model="message"
						type="text"
						:label="`${$t('Type your message here')}:`"
						class="feedback__input"
						required
						:isTextarea="true"
					/>
				</div>
				<p v-if="feedbackMessage" class="feedback__message">
					{{ feedbackMessage }}
				</p>
				<BaseButton
					class="feedback__submit _btn-primary"
					type="submit"
					:disabled="isLoading"
				>
					{{ isLoading ? $t('Sending...') : $t('Send Feedback') }}
				</BaseButton>
			</form>
		</div>
	</div>
</template>

<script>
import BaseButton, { ButtonThemes } from '@/components/base/BaseButton.vue';
import BaseInput from '@/components/base/BaseInput.vue';

export default {
	name: 'FeedbackForm',
	components: { BaseButton, BaseInput },
	data() {
		return {
			ButtonThemes,
			name: '',
			surname: '',
			phone: '',
			email: '',
			address: '',
			message: '',
			feedbackMessage: '',
			status: '',
			isLoading: false,
		};
	},
	methods: {
		sendFeedback() {
			this.clearError();
			if (this.isLoading) return;
			this.isLoading = true;

			this.$http
				.post(`${process.env.VUE_APP_API}feedback`, {
					name: this.name,
					surname: this.surname,
					email: this.email,
					phone: this.phone,
					address: this.address,
					message: this.message,
				})
				.then((response) => {
					if (response.data.status === 'OK') {
						this.$toast.success(
							this.$t('Your feedback has been sent successfully!')
						);
						this.name = '';
						this.surname = '';
						this.email = '';
						this.phone = '';
						this.address = '';
						this.message = '';
					} else {
						this.showError(response.data.message);
					}
				})
				.catch((error) => {
					console.error(error);
					this.showError(
						error.response?.data?.message ||
							this.$t('An error occurred while sending your feedback.')
					);
				})
				.finally(() => {
					this.isLoading = false;
				});
		},
		showError(errorMessage) {
			this.status = 'ERROR';
			this.feedbackMessage = errorMessage;
			setTimeout(() => this.clearError(), 6000);
		},
		clearError() {
			this.status = '';
			this.feedbackMessage = '';
		},
	},
};
</script>

<style scoped lang="scss">
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.feedback {
	@include header-indent;
	@include adaptiveValue('padding-top', 60, 25);
	@include adaptiveValue('padding-bottom', 60, 25);
	position: relative;
	min-height: calc(100vh - 98px);
	@media (max-width: $md1) {
		min-height: calc(100vh - 70px);
	}
	@media (max-width: $md4) {
		min-height: calc(100vh - 50px);
	}
	&::before {
		content: '';
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background-image: url('@/assets/images/bg/vertical-bg.png');
		background-repeat: no-repeat;
		background-size: contain;
		background-size: 100% 100%;
		z-index: -1;
	}
	&__title {
		display: block;
		text-align: center;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 30, 15);
		}
	}
	&__form {
		max-width: 710px;
		margin: 0 auto;
	}
	&__body {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 30, 15);
		}
	}
	&__raw {
		display: flex;
		gap: 20px;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 15, 10);
		}
	}
	&__input {
		flex: 1 1 auto;
		width: 100%;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 15, 10);
		}
	}
	&__message {
		font-family: var(--font-family-inter);
		font-size: 16px;
		line-height: 120%;
		font-weight: 500;
		display: block;
		text-align: center;
		margin-bottom: 8px;
		color: var(--error-color);
	}
	&__submit {
		max-width: 224px;
		min-height: 40px;
		margin-left: auto;
		margin-right: auto;
	}
}
</style>
